export default "__VITE_ASSET__DO3JmSXe__"